import { mergeStrings } from "../../order/utils/orderHelpers"
import { checkPermissions, isIdmUser } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getCustomer } from "../../shared/utils/getCustomer"

export const queryCustomerAnniversaries = {
  async customerAnniversaries(_parent, args, context, _info) {
    const { customerId } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CUSTOMERS,
      operation: Operations.READ,
    })

    if (!isIdmUser(user?.role)) {
      return null
    }

    const customer = await getCustomer({ id: customerId })

    if (!customer) {
      return null
    }

    const { id, customerNumber, companyName, custom, addresses } = customer
    const customersData = []

    // Check birthday anniversaries
    addresses?.forEach(({ firstName, lastName, custom }) => {
      const birthdayDate = custom?.fields?.dateOfBirth

      customersData.push({
        customerId: id,
        customerNumber,
        name: mergeStrings([firstName, lastName]),
        date: birthdayDate,
        type: "birthday",
      })
    })

    // Check founding anniversary
    const foundingDate = custom?.fields?.foundingDate

    customersData.push({
      customerId: id,
      customerNumber,
      name: companyName,
      date: foundingDate,
      type: "founding",
    })

    return {
      items: customersData,
    }
  },
}
